import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {Ric, RicDTOApiResponse} from "./types";
import {columnFiltersParamWithDateRange2, sortingParam2} from "../../common/Services";
import * as Yup from "yup";
import {DropAttivitaApiResponse} from "../../common/types";


const moment = require('moment')

export function useGetRicDTO(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<RicDTOApiResponse>({
        queryKey: [
            'fetchRicDTO',
            columnFilters,
            globalFilter,
            pagination.pageIndex,
            pagination.pageSize,
            sorting,

        ],
        queryFn: async () => {

            let coddip = localStorage.getItem('coddip') || '';
            const keyrole = localStorage.getItem('keyrole') || '';

            const isAdmin =  keyrole.includes('TimeReportAdmin') ;

            const myLimit=pagination.pageSize
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;

            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange2(
                columnFilters
            )}&ordering=${sortingParam2(sorting)}`;




            if (!isAdmin) {
                        myURL += `&coddip=${coddip}`;
                }


            // console.log('myURL',myURL);

            const response = await AxiosInstance.get(`ricdto/${myURL}`);

            return response.data;
        },
        refetchOnWindowFocus: false,
    });
}



export function useGetRic(idric: number) {
  return useQuery<Ric>({
    queryKey: ['fetchRic', idric],
    queryFn: async () => {
      const response = await AxiosInstance.get('ric/' + idric + '/');


      const transformedData = response.data?.data?.Ric;



      return transformedData;
    },
    refetchOnWindowFocus: false,
  });
}






export function useCreateRic() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (Ric: Ric) => {
      if (Ric.dataapertura) {
        Ric.dataapertura = moment(Ric.dataapertura).format('YYYY-MM-DD');
      }

      if (Ric.datachiusura) {
        Ric.datachiusura = moment(Ric.datachiusura).format('YYYY-MM-DD');
      }


        // console.log('add Ric', Ric);

       const response = await AxiosInstance.post('ric/0/',Ric);
       return response.data;

      // return AxiosInstance.post('Ric/0/',mapRicToJson(Ric));
    },

     onSuccess: async (data, variables) => {

         queryClient.invalidateQueries({ queryKey: ['fetchRicDTO'] });

   }, //refetch VersoOre after mutation, disabled for demo
     });
}

 export function useUpdateRic() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (nc: Ric) => {
     if (nc.dataapertura) {
        nc.dataapertura = moment(nc.dataapertura).format('YYYY-MM-DD');
      }

      if (nc.datachiusura) {
        nc.datachiusura = moment(nc.datachiusura).format('YYYY-MM-DD');
      }

        const response = await AxiosInstance.patch('ric/'+nc.idric+'/',nc);
        return response.data;
    },
    onSuccess: async (data, variables) => {
        queryClient.invalidateQueries({ queryKey: ['fetchRicDTO'] });

    },
  });
}





export function useDeleteRic() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (idric: number) => {


    const response = await AxiosInstance.delete('ric/'+idric+'/');
     return  response.data
    },
     onSuccess: async (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['fetchRicDTO'] });
    },
  });
}



export function useGetDropCatRic() {
  return useQuery<DropAttivitaApiResponse>({
    queryKey: ['fetchuseGetDropCatRic'],
    queryFn: async () => {
      const response = await AxiosInstance.get('dropcatric/?limit=10000&offset=0');
      return response.data
    },
    refetchOnWindowFocus: false,
  });
}


export function useGetDropStatiRic() {
  return useQuery<DropAttivitaApiResponse>({
    queryKey: ['fetchuseGetDropStatiRic'],
    queryFn: async () => {
      const response = await AxiosInstance.get('dropstatiric/?limit=10000&offset=0');
      return response.data
    },
    refetchOnWindowFocus: false,
  });
}

export function useGetDropLivelliRic() {
  return useQuery<DropAttivitaApiResponse>({
    queryKey: ['fetchuseGetDropLivelliRic'],
    queryFn: async () => {
      const response = await AxiosInstance.get('droplivelliric/?limit=10000&offset=0');
      return response.data
    },
    refetchOnWindowFocus: false,
  });
}











export const validationSchemaRic = Yup.object({
  dataric: Yup.date().nullable(),
  ditta: Yup.number().required("Ditta obbligatoria"),
  idprog: Yup.mixed<string | number>().nullable(),
  coddip: Yup.string().max(20).default(""),
  titolo: Yup.string().max(20).required("Titolo obbligatorio"),
  note: Yup.string().max(2000).default(""),
  canale: Yup.string().max(20).default(""),
  codcli: Yup.number().nullable(),
  refcliente: Yup.string().max(150).default(""),
  idcatric: Yup.number().required("Categoria obbligatoria"),
  idstatoric: Yup.number().required("Stato obbligatorio"),
  idlivelloric: Yup.number().required("Livello obbligatorio"),
  dataapertura: Yup.date().nullable(),
  datachiusura: Yup.date().nullable(),
  datavalutazione: Yup.date().nullable(),
  valutatore: Yup.string().max(100).default(""),
});